import React from 'react';
import * as Ui from './styles';

export function IconButton({
  // um dos componentes de Icons
  iconComponent,
  // o tamanho do ícone
  iconSize,
  // a cor do ícone
  iconColor,
  // a cor das borda do ícone
  iconStroke,
  // propaga o evento de click no ícone
  onClick,
  title,
}) {
  // cria uma instância local do ícone
  const IconInstance = (props) => {
    const Icon = iconComponent;
    return (<Icon {...props} />);
  };
  return (
    <Ui.Action color={iconColor} stroke={iconStroke} clear onClick={onClick}>
      <IconInstance size={iconSize} title={title} />
    </Ui.Action>
  );
}
